import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const { Button, Box, Title } = vp;

type TwoFactorAuthenticationQRCodeProps = {
  handleContinue: () => void;
  QRCode: string;
};

type FC = FunctionComponent<TwoFactorAuthenticationQRCodeProps>;
const TwoFactorAuthenticationQRCode: FC = (props: TwoFactorAuthenticationQRCodeProps) => {
  const { handleContinue, QRCode } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'Login.MFA.QRCode' });

  return (
    <Box flx="col">
      <Box mb="sm" flx="col" ai="center" height="auto">
        <Title title={t('title')} bold size="xsm" />
      </Box>
      <Box ai="center" jc="center" pb="md">
        <img src={QRCode} alt="QR Code" />
      </Box>
      <Box jc="fe" flx="col" height="auto">
        <Button
          id="enable-2-fa"
          type="button"
          label={t('nextButton')}
          size="xlg"
          textSize={1}
          onClick={() => {
            handleContinue();
          }}
        />
      </Box>
    </Box>
  );
};
export default TwoFactorAuthenticationQRCode;
